// react_frontend/src/Components/Router/PublicRouter.js
import { createBrowserRouter } from "react-router-dom";
import Auth from "../Modules/Auth";
import Login from "../Layouts/Login";
import AddCompany from "../Modules/addCompany";
import StrictPublicRoute from "./StrictPublicRoute";
import Payment from "../Modules/Payment";
import ChoosePackage from "../Modules/ChoosePackage";
import ForgotPassword from "../Modules/ForgotPassword";
import ResetPassword from "../Modules/ResetPassword";

const PublicRouter = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    children: [
      {
        path: "/",
        element: (
          <StrictPublicRoute>
            <Auth />
          </StrictPublicRoute>
        ),
      },
      {
        path: "/forgot-password",
        element: (
          <StrictPublicRoute>
            <ForgotPassword />
          </StrictPublicRoute>
        ),
      },
      {
        path: "/reset-password",
        element: (
          <StrictPublicRoute>
            <ResetPassword />
          </StrictPublicRoute>
        ),
      },
      {
        path: "/company-register",
        element: (
          <StrictPublicRoute>
            <AddCompany />
          </StrictPublicRoute>
        ),
      },
      {
        path: "/payment",
        element: (
          <StrictPublicRoute>
            <Payment />
          </StrictPublicRoute>
        ),
      },
      {
        path: "/choose-package",
        element: (
          <StrictPublicRoute>
            <ChoosePackage />
          </StrictPublicRoute>
        ),
      },
      {
        path: "*",
        element: (
          <StrictPublicRoute>
            <Auth /> {/* Redirect to login for non-auth users */}
          </StrictPublicRoute>
        ),
      },
    ],
  },
]);

export default PublicRouter;